"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTypExternisty = exports.getRoleOsoby = exports.getDruhZnalce = exports.getDruhOsoby = void 0;
/* eslint-disable react/no-array-index-key */
var ramda_1 = require("ramda");
var react_1 = __importDefault(require("react"));
var __1 = require("../..");
var __2 = require("../../../../..");
var useBoolean_1 = __importDefault(require("../../../../../hooks/useBoolean"));
var getDruhOsoby = function (druhOsobyZnalce) {
    // musime si premapovat druh osoby znalce na druh osoby pro ucely posudku
    switch (druhOsobyZnalce) {
        // znalec
        case __2.ZnalciDruhOsoby.znalec:
            return { id: __2.PosudkyTypOsoby.FyzickaOsobaPodnikajici };
        // kancelar
        case __2.ZnalciDruhOsoby.znaleckaKancelar:
            return { id: __2.PosudkyTypOsoby.PravnickaOsoba };
        // ustav
        case __2.ZnalciDruhOsoby.znaleckyUstav:
            return { id: __2.PosudkyTypOsoby.PravnickaOsoba };
        default:
            return { id: __2.PosudkyTypOsoby.FyzickaOsoba };
    }
};
exports.getDruhOsoby = getDruhOsoby;
var getDruhZnalce = function (role) {
    if (role === __2.PosudkyRoleOsoby.ZnalecPodilejiciNaZpracovani || role === __2.PosudkyRoleOsoby.Znalec || role === __2.PosudkyRoleOsoby.ZpracovatelZnalecVRamciZKneboZU)
        return { id: __2.ZnalciDruhOsoby.znalec, nazev: 'Znalec' };
    if (role === __2.PosudkyRoleOsoby.ZnaleckaKancelar || role === __2.PosudkyRoleOsoby.ZnaleckaKancelarPodilejiciNaZpracovani)
        return { id: __2.ZnalciDruhOsoby.znaleckaKancelar, nazev: 'Znalecká kancelář' };
    return { id: __2.ZnalciDruhOsoby.znaleckyUstav, nazev: 'Znalecký ústav' };
};
exports.getDruhZnalce = getDruhZnalce;
var getRoleOsoby = function (druhOsobyZnalce, podilejici) {
    if (!podilejici) {
        switch (druhOsobyZnalce) {
            case __2.ZnalciDruhOsoby.znalec:
                return { id: __2.PosudkyRoleOsoby.Znalec };
            case __2.ZnalciDruhOsoby.znaleckaKancelar:
                return { id: __2.PosudkyRoleOsoby.ZnaleckaKancelar };
            case __2.ZnalciDruhOsoby.znaleckyUstav:
                return { id: __2.PosudkyRoleOsoby.ZnaleckyUstav };
            default:
                return { id: __2.PosudkyRoleOsoby.Zpracovatel };
        }
    }
    switch (druhOsobyZnalce) {
        case __2.ZnalciDruhOsoby.znalec:
            return { id: __2.PosudkyRoleOsoby.ZnalecPodilejiciNaZpracovani };
        case __2.ZnalciDruhOsoby.znaleckaKancelar:
            return { id: __2.PosudkyRoleOsoby.ZnaleckaKancelarPodilejiciNaZpracovani };
        case __2.ZnalciDruhOsoby.znaleckyUstav:
            return { id: __2.PosudkyRoleOsoby.ZnaleckyUstavPodilejiciNaZpracovani };
        default:
            return { id: __2.PosudkyRoleOsoby.OsobaPodilejiciNaZpracovani };
    }
};
exports.getRoleOsoby = getRoleOsoby;
var getTypExternisty = function (value) {
    switch (value) {
        case 1:
            return __2.PosudkyRoleOsoby.OsobaZapojenaDoVedeckovyzkumneCinnosti;
        default:
            return __2.PosudkyRoleOsoby.OsobaVeSluzebnimPomeru;
    }
};
exports.getTypExternisty = getTypExternisty;
var PridatZpracovatelePopup = function (_a) {
    var _b, _c;
    var zpracovatele = _a.zpracovatele, datumZadani = _a.datumZadani, addZpracovatel = _a.addZpracovatel, podilejici = _a.podilejici, selectedZpracovatel = _a.selectedZpracovatel;
    var isZvolitPodilejiciOsoby = useBoolean_1.default(selectedZpracovatel ? ((_b = selectedZpracovatel.role) === null || _b === void 0 ? void 0 : _b.id) !== __2.PosudkyRoleOsoby.Znalec && ((_c = selectedZpracovatel.role) === null || _c === void 0 ? void 0 : _c.id) !== __2.PosudkyRoleOsoby.ZnalecPodilejiciNaZpracovani : false);
    var handleAdd = function (item, form) {
        var _a, _b, _c, _d, _e, _f;
        if (item.druhOsoby === __2.ZnalciDruhOsoby.znalec) {
            var znalec = item.soudniZnalec;
            if (znalec === null || znalec === void 0 ? void 0 : znalec.jeClenem) {
                form.setSubmitting(false);
                if (!datumZadani || (znalec.datumClenstvi && new Date(new Date(znalec.datumClenstvi).toDateString()).getTime() <= new Date(datumZadani).getTime())) {
                    form.setStatus({
                        message: "Znalec je \u010Dlenem znaleck\u00E9 kancel\u00E1\u0159e. Pokud m\u00E1 b\u00FDt doty\u010Dn\u00FD znalec zaps\u00E1n jako " + (podilejici ? 'spolupracující osoba' : 'zpracovatel') + ", mus\u00ED b\u00FDt den zad\u00E1n\u00ED posudku datov\u00E1n d\u0159\u00EDve ne\u017E datum vzniku \u010Dlenstv\u00ED znalce ve znaleck\u00E9 kancel\u00E1\u0159i.",
                        type: 'error',
                    });
                    return;
                }
            }
        }
        var newValues = {
            idSubjekt: item.id,
            jmeno: (_a = item.soudniZnalec) === null || _a === void 0 ? void 0 : _a.jmeno,
            prijmeni: (_b = item.soudniZnalec) === null || _b === void 0 ? void 0 : _b.prijmeni,
            nazev: item.soudniZnalec ? undefined : item.nazev,
            adresaSidla: (_c = item.adresa) === null || _c === void 0 ? void 0 : _c.adresaText,
            druh: exports.getDruhOsoby(item.druhOsoby),
            titulPred: (_d = item.soudniZnalec) === null || _d === void 0 ? void 0 : _d.titul,
            titulZa: (_e = item.soudniZnalec) === null || _e === void 0 ? void 0 : _e.titulZa,
            role: exports.getRoleOsoby(item.druhOsoby, podilejici),
            ico: item.ico,
            datumClenstvi: (_f = item.soudniZnalec) === null || _f === void 0 ? void 0 : _f.datumClenstvi,
            datoveSchranky: item.datoveSchranky,
            id: item.idOsoba,
            znalecne: item.znalecne,
        };
        addZpracovatel(newValues, form);
    };
    var defaultZnalec = function () {
        if (!selectedZpracovatel)
            return undefined;
        var druhZnalce = exports.getDruhZnalce(selectedZpracovatel.role.id);
        var def = {
            id: selectedZpracovatel.idSubjekt,
            soudniZnalec: druhZnalce.id === __2.ZnalciDruhOsoby.znalec
                ? {
                    jmeno: selectedZpracovatel.jmeno,
                    prijmeni: selectedZpracovatel.prijmeni,
                    titul: selectedZpracovatel.titulPred,
                    titulZa: selectedZpracovatel.titulZa,
                    datumClenstvi: selectedZpracovatel.datumClenstvi,
                }
                : null,
            adresa: __assign(__assign({}, selectedZpracovatel.adresa), { adresaText: selectedZpracovatel.adresaSidla }),
            ico: selectedZpracovatel.ico,
            druhOsoby: druhZnalce.id,
            nazev: selectedZpracovatel.nazev,
            obory: [],
            okres: '',
            obec: '',
            datoveSchranky: selectedZpracovatel.datoveSchranky,
            idOsoba: selectedZpracovatel.id,
            zarazenKancelar: false,
            druhOsobyNazev: druhZnalce.nazev,
            specializaceIds: [],
            znalecne: selectedZpracovatel.znalecne,
        };
        return def;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(__1.DruhOsobyForm, { onSubmit: handleAdd, setSelected: function (znalec) {
                isZvolitPodilejiciOsoby.setValue((znalec === null || znalec === void 0 ? void 0 : znalec.druhOsoby) !== __2.ZnalciDruhOsoby.znalec && znalec !== undefined);
            }, druhyOsob: [__2.ZnalciDruhOsoby.znalec, __2.ZnalciDruhOsoby.znaleckaKancelar, __2.ZnalciDruhOsoby.znaleckyUstav], labels: {
                search: 'Zadejte jméno, IČO nebo ID datové schránky osoby',
                submit: isZvolitPodilejiciOsoby.value ? 'Zvolit podílející se osoby' : (selectedZpracovatel ? 'Upravit' : 'Přidat') + " osobu",
            }, filterResult: function (_a) {
                var id = _a.id;
                return !ramda_1.includes(id, ramda_1.pluck('idSubjekt', zpracovatele));
            }, defaultSelected: defaultZnalec() })));
};
PridatZpracovatelePopup.defaultProps = {
    datumZadani: undefined,
    podilejici: false,
    selectedZpracovatel: undefined,
};
exports.default = PridatZpracovatelePopup;
